import { useNavigate } from 'react-router-dom';

import { useContaBloqueada as useContaBloqueadaDoNucleo } from '@maestra/core/telas/auth/useContaBloqueada';

// A CONTA BLOQUEADA POR DECLARAÇÃO DE MENORIDADE: a regra mora no núcleo desde 01/11/2026, e o app
// usa a mesma (docs/PLANO-APP-NATIVO.md). A web entrega o `navigate`.

export const useContaBloqueada = () => useContaBloqueadaDoNucleo({ ir: useNavigate() });
